module.exports = __webpack_public_path__ + "img/IMG_9519_L_Black.3955aefd.jpg";